// these constants need to be in a separate file as they are used in cypress tests and we want to avoid build issues
// which occur when defined in the main useTracking file
export const COOKIE_DISABLE_TRACKING_KEY = "DISABLE_TRACKING";
export const COOKIE_DISABLE_TRACKING_VALUE = "true";
